var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconOther(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      isolation: "isolate"
    },
    viewBox: "0 0 64 64",
    width: "64pt",
    height: "64pt",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clipPath_TWTqHaiBVc559q6NmOAoEBZYfZDf4H9Z"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clipPath_TWTqHaiBVc559q6NmOAoEBZYfZDf4H9Z)"
  }, /*#__PURE__*/React.createElement("circle", {
    vectorEffect: "non-scaling-stroke",
    cx: 10.480000000000004,
    cy: 32,
    r: 6.519999999999997,
    fill: "none",
    strokeWidth: 3,
    stroke: "rgb(255,255,255)",
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("circle", {
    vectorEffect: "non-scaling-stroke",
    cx: 53.519999999999996,
    cy: 32,
    r: 6.519999999999996,
    fill: "none",
    strokeWidth: 3,
    stroke: "rgb(255,255,255)",
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("circle", {
    vectorEffect: "non-scaling-stroke",
    cx: 32,
    cy: 32,
    r: 6.519999999999996,
    fill: "none",
    strokeWidth: 3,
    stroke: "rgb(255,255,255)",
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOther);
export default __webpack_public_path__ + "static/media/Icon_other.c88e0291bed0343cca902258c793f321.svg";
export { ForwardRef as ReactComponent };